module.exports = __webpack_public_path__ + "img/white-90rotate-icon.c3aa027d.svg";